<template>
  <div>
    <el-row class="container" :gutter="20">
      <!-- Filtros -->
      <el-col class="container_col_1" :span="6">
        
        <el-row style="margin-bottom:15px;">
          <el-col :span="24">
            <div class="title">{{ $t('FIRMAR_REMITOS_titulo') }}</div>
          </el-col>
        </el-row>

        <!-- Filtros de búsqueda -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item :title="$t('GENERAL_Busqueda')" name="0">
              <div class="filters">
                <div class="filters_item">
                  <div class="label">{{ $t('FIRMAR_REMITOS_filtro_id') }}</div>
                  <el-input
                    :placeholder="$t('FIRMAR_REMITOS_filtro_id_placeholder')"
                    size="small"
                    v-model="filtros.numeroRemito"
                    @input="getRemitosDelayed"
                    clearable
                  />
                </div>

                <div class="filters_item">
                  <div class="label">{{ $t('FIRMAR_REMITOS_filtro_estado') }}</div>
                  <el-select
                    class="seleccionador"
                    v-model="filtros.firmado"
                    size="small"
                    @change="getRemitos"
                  >
                    <el-option :value="false" :label="$t('FIRMAR_REMITOS_filtro_no_firmados')"></el-option>
                    <el-option :value="true" :label="$t('FIRMAR_REMITOS_filtro_firmados')"></el-option>
                  </el-select>
                </div>

                <div class="clearFilters" @click="cleanFilters">{{ $t('GENERAL_clean_filters') }}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados -->
      <el-col class="container_col_2" :span="18">
        <el-row style="margin-bottom:15px;" type="flex" justify="space-between" align="middle">
          <el-col :span="12">
            <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          
          <el-col :span="12" class="pagination_container">
            <el-pagination              
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>

        <el-row>
          <el-table
            :data="remitos"
            border
            header-row-class-name="table-header"
            v-loading="loading"
            :empty-text="$t('GENERAL_no_data')"
            row-class-name="tablaRemitos"
            :row-style="tableRowStyle"
            :fit="filtros.firmado"
            :style="{ width: 'max-content' }">
            
            <el-table-column
              prop="Fecha"
              :label="$t('FIRMAR_REMITOS_tabla_fecha')"
              :width="filtros.firmado ? 100 : 135"
              align="center">
              <template slot-scope="scope">
                {{ scope.row.Fecha | formatDate }}
              </template>
            </el-table-column>

            <el-table-column
              prop="Tipo"
              :label="$t('FIRMAR_REMITOS_tabla_tipo')"
              :width="filtros.firmado ? 55 : 80"
              align="center">
            </el-table-column>
            <el-table-column
              prop="Serie"
              label="Serie"
              :width="filtros.firmado ? 60 : 90"
              align="center">
            </el-table-column>
            <el-table-column
              prop="PV"
              label="Suc."
              :width="filtros.firmado ? 60 : 90"
              align="center">
            </el-table-column>
            <el-table-column
              prop="Nro"
              :label="$t('FIRMAR_REMITOS_tabla_nro')"
              :width="filtros.firmado ? 90 : 120"
              align="center">
            </el-table-column>

            <el-table-column
              prop="CantidadItems"
              :label="$t('FIRMAR_REMITOS_tabla_cant_items')"
              :width="filtros.firmado ? 100 : 130"
              align="center">
            </el-table-column>

            <el-table-column
              :label="$t('FIRMAR_REMITOS_tabla_acciones')"
              :width="filtros.firmado ? 85 : 100"
              align="center">
              <template slot-scope="scope">
                <div style="display: flex; justify-content: center; align-items: center;">
                  <!-- Ícono Descargar PDF -->
                  <el-tooltip effect="dark" :content="$t('FIRMAR_REMITOS_descargar_pdf')" placement="top">
                    <img 
                      v-if="!scope.row.descargando"
                      src="@/assets/images/file-pdf.svg"
                      class="icon-action icon-pdf" 
                      @click="descargarPDF(scope.row)"
                      alt="PDF">
                    <i v-else class="icon-action el-icon-loading"></i>
                  </el-tooltip>
                  
                  <!-- Ícono Firmar (solo si no está firmado) -->
                  <el-tooltip
                    v-if="!isRemitoSigned(scope.row)"
                    effect="dark"
                    :content="$t('FIRMAR_REMITOS_firmar')"
                    placement="top">
                    <i
                      class="icon-action el-icon-edit-outline"
                      @click="abrirModalFirmar(scope.row)">
                    </i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="filtros.firmado"
              prop="Por"
              :label="$t('FIRMAR_REMITOS_tabla_por')"
              width="120">
              <template slot-scope="scope">
                <div style="white-space: normal; word-break: keep-all; overflow-wrap: anywhere;">
                  {{ scope.row.Por }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="filtros.firmado"
              prop="El"
              :label="$t('FIRMAR_REMITOS_tabla_el')"
              width="100"
              align="center">
              <template slot-scope="scope">
                {{ scope.row.El | formatDate }}
              </template>
            </el-table-column>

            <el-table-column
              v-if="filtros.firmado"
              prop="FirmaNotas"
              :label="$t('FIRMAR_REMITOS_tabla_firma_notas')"
              min-width="200">
            </el-table-column>

            <el-table-column
              v-if="filtros.firmado"
              :label="$t('FIRMAR_REMITOS_tabla_conforme')"
              width="105"
              align="center">
              <template slot-scope="scope">
                <div class="firma-conforme-cell">
                  <el-tag v-if="scope.row.FirmaConforme === 'S'" class="firma-conforme-tag" type="success" size="mini">
                    <i class="el-icon-check firma-conforme-icon"></i>
                  </el-tag>
                  <el-tag v-else-if="scope.row.FirmaConforme === 'N'" class="firma-conforme-tag" type="danger" size="mini">
                    <span class="firma-conforme-x">×</span>
                  </el-tag>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </el-row>
        
        <!-- Paginador abajo -->
        <el-row class="paginator_bottom">
          <el-col :span="24">
            <el-pagination         
            background
            small
            layout="prev, pager, next"
            :current-page="paginador.page"
            :page-count="paginador.nro_pages"
            :page-size="paginador.pageSize"
            @current-change="handlePageChange"
            :pager-count="5"
            hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>

      </el-col>
    </el-row>

    <!-- Modal de confirmación de firma -->
    <el-dialog
      :title="getTituloModal()"
      :visible.sync="modalFirmar.visible"
      width="500px"
      custom-class="modal-firmar-remito">
      
      <div>
        <el-form label-position="top">
          <div class="confirmacion-texto">
            {{ $t('FIRMAR_REMITOS_modal_confirmacion') }}
          </div>
          
          <el-form-item :label="$t('FIRMAR_REMITOS_modal_notas')" class="form-item-notas">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              :placeholder="$t('FIRMAR_REMITOS_modal_notas_placeholder')"
              v-model="modalFirmar.notas">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button class="btn-modal btn-cancelar" @click="modalFirmar.visible = false">{{ $t('GENERAL_cancelBtn') }}</el-button>
        <el-button 
          class="btn-modal btn-firma"
          type="success"
          @click="confirmarFirma('S')"
          :loading="modalFirmar.firmando">
          {{ $t('FIRMAR_REMITOS_modal_confirmar_conforme') }}
        </el-button>
        <el-button
          class="btn-modal btn-firma btn-firma-no-conforme"
          type="danger"
          @click="confirmarFirma('N')"
          :loading="modalFirmar.firmando">
          {{ $t('FIRMAR_REMITOS_modal_confirmar_no_conforme') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from "vuex"

  export default {
    name: "FirmarRemitos",
    data() {
      return {
        remitos: [],
        filtros: {
          numeroRemito: '',
          firmado: false
        },
        paginador: {
          page: 1,
          pageSize: 10,
          nro_pages: 0
        },
        loading: false,
        activeNames: ["0"],
        modalFirmar: {
          visible: false,
          remito: {},
          notas: '',
          firmando: false
        },
        timeoutId: null
      };
    },
    computed: {
      ...mapState({
        idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
      }),
      canFirmarNoConforme() {
        return !!(this.modalFirmar.notas && this.modalFirmar.notas.toString().trim());
      }
    },
    mounted() {
      console.log('ID Usuario en mounted:', this.idUsuario);
      console.log('Estado completo sesion:', this.$store.state.sesion);
      this.getRemitos();
    },
    beforeDestroy() {
      // Limpiar el timeout si existe
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    },
    methods: {
      tableRowStyle({ row, rowIndex }) {
        return 'padding: 5px 0px !important;'
      },
      getTituloModal() {
        const remito = this.modalFirmar.remito;
        if (!remito) return this.$t('FIRMAR_REMITOS_modal_titulo');
        
        return `${this.$t('FIRMAR_REMITOS_modal_titulo')} ${remito.Tipo} ${remito.Serie} ${remito.PV} ${remito.Nro}`;
      },
      handlePageChange(page) {
        this.paginador.page = page;
        this.getRemitos();
      },

      getRemitos() {
        this.loading = true;

        console.log('ID Usuario en getRemitos:', this.idUsuario);
        
        let payload = {
          page: this.paginador.page,
          pageSize: this.paginador.pageSize,
          numero: this.filtros.numeroRemito || '',
          firmado: this.filtros.firmado,
          usuarioId: this.idUsuario
        };
        
        console.log('Payload getRemitos:', payload);
        
        this.$store
          .dispatch("solicitudes/getRemitosFirmar", payload)
          .then(data => {
            if (data.CodigoResultado === 0) {
              this.paginador.nro_pages = data.Datos.TotalPaginas;
              this.remitos = data.Datos.Remitos.map(r => ({
                ...r,
                descargando: false // para estado de loading del botón
              }));
            } else {
              this.$message.error(data.MensajeError || this.$t('FIRMAR_REMITOS_error_cargar'));
            }
          })
          .catch(error => {
            this.$message.error(this.$t('FIRMAR_REMITOS_error_cargar'));
            console.error(error);
          })
          .finally(() => (this.loading = false));
      },

      getRemitosDelayed() {
        // Cancela el timeout anterior si existe
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        
        // Resetea la paginación al buscar
        this.paginador.page = 1;
        
        // Establece un nuevo timeout
        this.timeoutId = setTimeout(() => {
          this.getRemitos();
        }, 500);
      },

      cleanFilters() {
        this.filtros = {
          numeroRemito: '',
          firmado: false
        };
        this.paginador.page = 1;
        this.getRemitos();
      },

      descargarPDF(remito) {
        this.$set(remito, 'descargando', true);
        
        console.log('ID Usuario en descargarPDF:', this.idUsuario);
        const payload = {
          remitoId: remito.Id,
          usuarioId: this.idUsuario
        };
        console.log('Payload descargarPDF:', payload);
        
        this.$store
          .dispatch("solicitudes/getRemitoPDF", payload)
          .then(({ url, fileName }) => {
            // Crear link temporal y simular click
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Liberar URL temporal
            window.URL.revokeObjectURL(url);
            
            this.$message.success(this.$t('FIRMAR_REMITOS_pdf_descargado'));
          })
          .catch(error => {
            this.$message.error(this.$t('FIRMAR_REMITOS_error_descargar'));
            console.error(error);
          })
          .finally(() => {
            this.$set(remito, 'descargando', false);
          });
      },

      abrirModalFirmar(remito) {
        // No permitir abrir modal si ya está firmado (usa el comparador robusto)
        if (this.isRemitoSigned(remito)) {
          return;
        }

        this.modalFirmar = {
          visible: true,
          remito: remito,
          notas: '',
          firmando: false
        };
      },

      // Determina si un remito está firmado.
      // Reglas: si el campo de estado contiene una 'Z' (mayúscula o minúscula)
      // o si la fecha de firma (`El`) tiene cualquier valor, se considera firmado.
      isRemitoSigned(remito) {
        if (!remito) return false;
        const estado = remito.Estado || remito.EstadoFirma || '';
        const fechaFirma = remito.El || remito.FechaFirma || '';
        const firmaConforme = remito.FirmaConforme || remito.FIRMA_CONFORME || '';

        try {
          if (estado && estado.toString().toUpperCase().indexOf('Z') !== -1) return true;
        } catch (e) {
          // ignore
        }

        if (fechaFirma && fechaFirma !== '') return true;

        if (firmaConforme === 'S' || firmaConforme === 'N') return true;

        return false;
      },

      confirmarFirma(conforme) {
        if (conforme === 'N' && !this.canFirmarNoConforme) {
          this.$message.warning(this.$t('FIRMAR_REMITOS_nota_requerida_no_conforme'));
          return;
        }

        this.modalFirmar.firmando = true;
        
        console.log('ID Usuario en confirmarFirma:', this.idUsuario);
        const payload = {
          remitoId: this.modalFirmar.remito.Id,
          usuarioId: this.idUsuario,
          notas: this.modalFirmar.notas,
          conforme
        };
        console.log('Payload confirmarFirma:', payload);
        
        this.$store
          .dispatch("solicitudes/firmarRemito", payload)
          .then(data => {
            if (data.CodigoResultado === 0) {
              this.$message.success(this.$t('FIRMAR_REMITOS_firmado_exito'));
              this.modalFirmar.visible = false;
              this.getRemitos(); // Recargar lista
            } else {
              this.$message.error(data.MensajeError || this.$t('FIRMAR_REMITOS_error_firmar'));
            }
          })
          .catch(error => {
            this.$message.error(this.$t('FIRMAR_REMITOS_error_firmar'));
            console.error(error);
          })
          .finally(() => {
            this.modalFirmar.firmando = false;
          });
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    margin-top:15px;
    min-height: 500px !important;
    width:  100% !important;
  }
  .pagination_container {
    text-align: right;
    padding-right:0px;
  }
  .paginator_bottom{
    margin-top:10px;
    text-align: right;
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
    }
    .container_col_1 {
      flex: 1;
      width:100% !important;
    }
    .container_col_2 {
      flex: 1;
      width:100% !important;
      margin-top:20px;
    }
  }
  
  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
  }
  .sub-title {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: #999;
  }
  .filters {
    display: flex;
    flex-direction: column;
  }
  .filters_item {
    flex: 1;
    margin-bottom: 15px;
  }
  .label {
    text-align: left;
    margin-bottom: 4px;
    font-size: 14px;
  }
  .seleccionador {
    width: 100%;
    padding: 0;
  }
  .clearFilters {
    color: #5aabc6;
    font-size: 14px;
    text-align: left;
    margin-top: 10px;
    cursor: pointer;
  }
  .clearFilters:hover {
    color: var(--main-color);
    text-decoration: underline;
  }
  
  /* Responsive table */
  .el-table {
    overflow-x: auto;
  }
  
  /* Estilo de iconos de acciones (consistente con el resto del sistema) */
  .icon-action {
    font-size: 18px;
    margin: 0 5px;
    cursor: pointer;
    color: #606266;
  }
  
  .icon-action:hover {
    color: var(--main-color);
  }
  
  .icon-pdf {
    width: 18px;
    height: 18px;
    cursor: pointer;
    opacity: 0.6;
    filter: grayscale(0%);
    transition: filter 0.2s ease, opacity 0.2s ease;
  }
  
  .icon-pdf:hover {
    opacity: 1;
    filter: brightness(0) saturate(100%) invert(63%) sepia(52%) saturate(450%) hue-rotate(146deg) brightness(91%) contrast(89%);
  }
  
  .el-icon-loading {
    font-size: 18px;
    color: var(--main-color);
  }
  
  /* Estilos para el modal de firma */
  .confirmacion-texto {
    font-size: 15px;
    color: #606266;
    margin-bottom: 8px;
    line-height: 1.5;
  }
  
  .form-item-notas >>> .el-form-item__label {
    font-size: 11px;
    margin-bottom: 0px;
    padding-bottom: 0;
  }
  
  .form-item-notas >>> .el-textarea {
    margin-top: -10px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
  }

  .dialog-footer .el-button + .el-button {
    margin-left: 8px;
  }

  .btn-modal {
    padding: 8px 12px !important;
    white-space: nowrap;
  }

  .btn-cancelar {
    margin-right: auto;
  }

  .btn-firma {
    min-width: 90px;
  }

  .btn-firma-no-conforme:hover,
  .btn-firma-no-conforme:focus {
    background-color: #f56c6c !important;
    border-color: #f56c6c !important;
    color: #fff !important;
    box-shadow: 0 0 0 1px #f78989 inset !important;
  }

  .btn-firma-no-conforme:active,
  .btn-firma-no-conforme.is-active {
    background-color: #dd6161 !important;
    border-color: #dd6161 !important;
    color: #fff !important;
    box-shadow: 0 0 0 1px #c45656 inset !important;
  }

  .firma-conforme-cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .firma-conforme-tag {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 22px;
  }

  .firma-conforme-icon {
    display: block;
    margin: 0;
    line-height: 1;
    font-weight: 600;
  }

  .firma-conforme-x {
    display: block;
    margin: 0;
    line-height: 1;
    font-weight: 550;
    font-size: 16px;
  }
</style>

<style>
.el-table .tablaRemitos td, .el-table .tablaRemitos th {
    padding: 5px 0;
}

/* Reducir espaciado superior del modal */
.modal-firmar-remito .el-dialog__body {
  padding-top: 10px !important;
}
</style>
